import { Button, Grid } from "@mui/material";
import React, { useEffect } from "react";
import CustomInput from "../../CustomInput/CustomInput";
import DraggableDialog from "../../CustomDialogs/DraggableDialog";
import ListData from "./Components/listData";
import PropTypes from "prop-types";
import axios from "axios";
import { genURL } from "../../../_getjson";

export default function WareHouseRes(props) {
  const { productCode, defaultValue } = props;
  const [state, setState] = React.useState({
    warehouseRec: "",
    location: "",
    unit: "",
    openDialog: false,
    titleDialog: "เลือกคลัง",
    multiselects: false,
  });

  const [resultState, setResultState] = React.useState({
    warehouseRec: "",
    location: "",
    unit: "",
  });
  useEffect(() => {
    console.log("defaultValue", defaultValue);
    if (defaultValue[0].warehouse !== "") {
      getSiteData(defaultValue);
    }

    return () => {};
  }, [defaultValue[0].warehouse]);

  const getSiteData = async (e) => {
    // let rows = []
    console.log(e);
    if (typeof e[0].location !== "undefined") {
      let url =
        `CSWAREHOUSE/LOC?code=` + productCode + `&codeLOC=` + e[0].location;
      await axios.get(genURL(url)).then((res) => {
        console.log("res", res);
        if (res.data.length > 0) {
          setState((prevState) => ({
            ...prevState,
            warehouseRec: res.data[0].WHNAME,
            location: res.data[0].LOCNAME,
            unit: res.data[0].UNITNAME,
          }));
        }
      });
    }
  };
  useEffect(() => {
    try {
      props.resultData(resultState);
    } catch (error) {}
    return () => {};
  }, [resultState.warehouseRec, resultState.location, resultState.unit]);

  const resultData = (e) => {
    setState((prevState) => ({
      ...prevState,
      openDialog: false,
      warehouseRec: e[0].warehouse,
      location: e[0].location,
      unit: e[0].unit,
    }));
    setResultState((prevState) => ({
      ...prevState,
      warehouseRec: e[0].warehouseCode,
      location: e[0].locationCode,
      unit: e[0].unitCode,
    }));
    console.log(resultState);
  };
  return (
    <>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid item lg={4}>
          <CustomInput
            label={"รับเข้าคลัง"}
            inputType={"string"}
            defaultValue={state.warehouseRec}
            id={"warehouseRec"}
            readonly={true}
          />
        </Grid>

        <Grid item lg={4}>
          <CustomInput
            label={"ตำแหน่งเก็บ"}
            inputType={"string"}
            defaultValue={state.location}
            id={"location"}
            readonly={true}
          />
        </Grid>

        <Grid item lg={4}>
          <CustomInput
            label={"หน่วยนับ"}
            inputType={"string"}
            defaultValue={state.unit}
            id={"unit"}
            readonly={true}
          />
        </Grid>
        {/* {state.productCode != "" ? */}
        <Grid item lg={4}>
          <Button
            variant="outlined"
            onClick={() => {
              setState((prevState) => ({
                ...prevState,
                openDialog: true,
              }));
            }}
          >
            เลือกคลัง
          </Button>
        </Grid>
        {/* : console.log("productCode เป็นค่าว่าง") */}
        {/* } */}
        <DraggableDialog
          open={state.openDialog}
          title={state.titleDialog}
          closeDialog={(e) =>
            setState((prevState) => ({
              openDialog: false,
            }))
          }
        >
          <ListData
            resultData={(e) => resultData(e)}
            multiselect={state.multiselects}
            productCode={productCode}
          />
        </DraggableDialog>
      </Grid>
    </>
  );
}
WareHouseRes.propTypes = {
  productCode: PropTypes.string,
};
WareHouseRes.defaultValue = {
  productCode: "",
};
